module.exports = __webpack_public_path__ + "img/precision_bomber.76904107.jpg";